/* Förbeställning – Långholmen Kajak. Läser data från snippets/forbestallning.liquid. */
(function () {
  var PRE_BTN = 'Förbeställ – skickas ';
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* Adressen som besökaren kom in på (innan temat lägger till ?variant=). */
  var NAV_URL = location.href;
  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.name) NAV_URL = nav.name;
  } catch (e) {}
  var autoDone = /[?&]variant=/.test(NAV_URL);

  /* Förval: kommer kunden till produkten utan vald variant och första varianten är slut,
     väljs första varianten som finns i lager. Länkar med ?variant= respekteras alltid. */
  function autoSelect() {
    if (autoDone) return;
    var jsonEl = document.querySelector('[data-forbestallning-json]');
    if (!jsonEl) return;
    var root = jsonEl.closest('[data-section-id]');
    var pjEl = root && root.querySelector('[data-product-json]');
    var form = root && root.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    if (!pjEl || !idInput) return;
    autoDone = true;
    var data, pj;
    try { data = JSON.parse(jsonEl.textContent); pj = JSON.parse(pjEl.textContent); } catch (e) { return; }
    var cur = data[String(idInput.value)];
    if (!cur || cur.state === '') return;
    var target = null;
    each(pj.variants || [], function (v) {
      var d = data[String(v.id)];
      if (!target && v.available && d && d.state === '') target = v;
    });
    if (!target) return;
    /* Temat scrollar till variantens bild vid byte – stäng av det under förvalet så sidan stannar högst upp. */
    var origScrollTo = window.scrollTo;
    window.scrollTo = function () {};
    setTimeout(function () { window.scrollTo = origScrollTo; }, 1500);
    each(pj.options || [], function (opt, i) {
      var name = typeof opt === 'string' ? opt : (opt && opt.name);
      var val = target.options[i];
      var field = 'options[' + name + ']';
      each(root.querySelectorAll('input[type="radio"]'), function (inp) {
        if (inp.name === field && inp.value === val && !inp.checked) inp.click();
      });
      each(root.querySelectorAll('select'), function (sel) {
        if (sel.name === field && sel.value !== val) {
          sel.value = val;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function applyRoot(jsonEl) {
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var root = jsonEl.closest('[data-section-id]') || document;
    var msg = root.querySelector('[data-forbestallning-msg]');
    var form = root.querySelector('form[data-product-form]');
    if (!msg || !form) return;
    var msgText = msg.querySelector('[data-forbestallning-msg-text]');
    var stockWrap = root.querySelector('[data-remaining-wrapper]');
    var idInput = form.querySelector('[name="id"]');
    var btnText = form.querySelector('[data-add-to-cart-text]');
    if (!idInput) return;
    var prop = form.querySelector('input[name="properties[Leverans]"]');
    if (!prop) {
      prop = document.createElement('input');
      prop.type = 'hidden';
      prop.name = 'properties[Leverans]';
      prop.disabled = true;
      form.appendChild(prop);
    }
    var d = data[String(idInput.value)] || { state: '' };
    var nextEl = root.querySelector('[data-forbestallning-next]');
    if (nextEl) {
      var nt = (d.state === '' && d.low && d.next) ? 'Begränsat antal i lager – fler kommer ' + d.next : '';
      if (nextEl.textContent !== nt) nextEl.textContent = nt;
      var nd = nt ? '' : 'none';
      if (nextEl.style.display !== nd) nextEl.style.display = nd;
    }
    function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

    if (d.state === 'pre' || d.state === 'noinfo') {
      var line, propVal;
      if (d.state === 'pre') {
        line = 'Förbeställning – skickas ' + d.text + '. Varan finns inte i lager just nu.';
        propVal = 'Förbeställning – skickas ' + d.text;
        if (btnText) {
          if (!btnText.hasAttribute('data-fb-original') && btnText.textContent.indexOf('Förbeställ') === -1 && btnText.textContent.indexOf('Beställ –') === -1) {
            btnText.setAttribute('data-fb-original', btnText.textContent.trim());
          }
          setText(btnText, PRE_BTN + d.text);
        }
      } else {
        line = 'Beställningsvara – slut i lager just nu. Vi mejlar dig leveranstiden inom en arbetsdag efter din beställning.';
        propVal = 'Beställningsvara – leveranstid bekräftas via mejl';
        if (btnText) {
          if (!btnText.hasAttribute('data-fb-original') && btnText.textContent.indexOf('Beställ') === -1 && btnText.textContent.indexOf('Förbeställ') === -1) {
            btnText.setAttribute('data-fb-original', btnText.textContent.trim());
          }
          setText(btnText, 'Beställ – leveranstid bekräftas via mejl');
        }
      }
      setText(msgText, line);
      if (msg.style.display !== '') msg.style.display = '';
      if (stockWrap && stockWrap.style.display !== 'none') stockWrap.style.display = 'none';
      if (prop.value !== propVal) prop.value = propVal;
      prop.disabled = false;
    } else {
      if (msg.style.display !== 'none') msg.style.display = 'none';
      if (stockWrap && stockWrap.style.display === 'none') stockWrap.style.display = '';
      prop.value = '';
      prop.disabled = true;
      if (btnText && (btnText.textContent.indexOf('Förbeställ') !== -1 || btnText.textContent.indexOf('Beställ –') !== -1)) {
        setText(btnText, btnText.getAttribute('data-fb-original') || (window.theme && theme.strings && theme.strings.add_to_cart) || 'Lägg i varukorg');
      }
    }
  }

  function run() { each(document.querySelectorAll('[data-forbestallning-json]'), applyRoot); }

  function later() { run(); setTimeout(run, 80); setTimeout(run, 400); }

  function startAuto() { setTimeout(function () { autoSelect(); later(); }, 60); }

  document.addEventListener('change', later, true);
  document.addEventListener('click', function () { setTimeout(later, 0); }, true);
  document.addEventListener('submit', run, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', later);
  } else {
    later();
  }
  if (document.readyState === 'complete') {
    startAuto();
  } else {
    window.addEventListener('load', startAuto);
  }
  window.addEventListener('load', later);
  setInterval(run, 500);
})();
